module.exports = __webpack_public_path__ + "static/img/aanchal_profile_pic_png.c803c3f6.png";